// extracted by mini-css-extract-plugin
export default {"companyName":"amlChecks_companyName__tD2ZV","userFullName":"amlChecks_userFullName__thfuD"};